export const OG_WIDTH = 1200;
export const OG_HEIGHT = 630;
